import 'css-chunksrc/client/pages/projectPage/ganttPage/styles.scss';export default {
  "ganttPage": "_ganttPage_ixikd_1",
  "projectEdition": "_projectEdition_ixikd_8",
  "projectEditionOverlay": "_projectEditionOverlay_ixikd_20",
  "projectEditionMain": "_projectEditionMain_ixikd_29",
  "exportButton": "_exportButton_ixikd_37"
};